import { SupportedMonacoEditorLanguage } from "@/components/source/EditorTypes";
import toast from "react-hot-toast";

export const copySourcePath = async (path: string): Promise<void> => {
  try {
    await navigator.clipboard.writeText(path);
    toast.success("Copied path");
  } catch {
    toast.error("Could not copy path");
  }
};

export const resolverSourceToSourceQuery = (
  filename: string,
  line?: number,
  extent?: number,
): string => {
  return (
    `filename=${encodeURIComponent(filename)}` +
    (line != null ? `&startLineNumber=${line}` : "") +
    (extent != null && line != null ? `&endLineNumber=${line + extent}` : "")
  );
};

export const filenameToLanguage = (filename: string): SupportedMonacoEditorLanguage => {
  const extension = filename.split(".").pop();
  switch (extension) {
    case "md":
      return "markdown";
    case "sql":
      return "sql";
    case "yml":
    case "yaml":
      return "yaml";
    case "py":
      return "python";
    case "sh":
      return "shell";
    case "ipynb":
      return "json";
    case "json":
      return "json";
    case "ini":
      return "ini";
    case "js":
      return "javascript";
    case "ts":
      return "typescript";
    default:
      return "plaintext";
  }
};
